module.exports = __webpack_public_path__ + "static/img/4.1c5e739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/4.png
// module id = UAs6
// module chunks = 0